import { Component } from 'react';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/** Generic error state: never exposes internals, offers a reload. */
export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override render() {
    if (this.state.hasError) {
      return (
        <main className="foundation-page">
          <section className="foundation-card" aria-labelledby="err-title">
            <h1 id="err-title">Something went wrong</h1>
            <p className="lede" role="alert">
              An unexpected error occurred. Reload the page to continue.
            </p>
            <button
              type="button"
              className="ui-button ui-button--primary ui-button--md"
              onClick={() => {
                window.location.reload();
              }}
            >
              Reload
            </button>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}
